import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommunicationService } from '../../../../core/services/communication.service';
import { takeUntil } from 'rxjs/internal/operators';
import { Subject } from 'rxjs';
import { NavigationEnd } from '@angular/router';
import { DeviceService } from '../../../../core/services/device.service';

@Component({
  templateUrl: './portal.page.html',
  styleUrls: ['./portal.page.scss']
})
export class PortalPage implements OnInit, OnDestroy {

  backgroundImage: any;
  private subscription$ = new Subject();

  constructor(private communicationService: CommunicationService,
    private deviceService: DeviceService) {
  }

  ngOnInit() {
    this.setHomeBackground();
    this.communicationService.routeChange$
      .pipe(takeUntil(this.subscription$))
      .subscribe((route: NavigationEnd) => {
        this.setBackgroundColor(route);
      });
  }

  setBackgroundColor(route: NavigationEnd) {
    const url = route.url.split('/').length;
    const urlAfterRedirects = route.urlAfterRedirects.split('/').length;
    if (url === 2 || urlAfterRedirects === 2) {
      this.setHomeBackground();
    } else {
      this.backgroundImage = {};
    } /*this.backgroundImage = {"background-image": "url('../../../../../assets/images/map.png')"};*/
  }

  setHomeBackground():void {
    if (this.deviceService.isMobile) {
      this.backgroundImage = { "background-image": "url('../../../../../assets/images/BG-home-page-no-map.png')" };
    } else {
      this.backgroundImage = { "background-image": "url('../../../../../assets/images/BG-home-page-with-map1.png')" };
    }
  }

  isMobile(): boolean{
    return this.deviceService.isMobile;
  }

  ngOnDestroy() {
    this.subscription$.next();
    this.subscription$.complete();
  }

}
